import React from "react";
import PropTypes from "prop-types";
import { forEach } from "lodash";
import { useSelector } from "react-redux";

import { Accordian } from "../../../../../../../../components/Accordian";
import { PrimaryBorrowerUAE } from "./PrimaryBorrowerUAE";
import { PrimaryBorrowerNonUAE } from "./PrimaryBorrowerNonUAE";
import { getDisplayTextUsingDatalistValue } from "../../../../../../../../utils/helper";
import { getDatalist } from "../../../../../../../../store/selectors/appConfig";

export const PrimaryBorrowerComponent = ({ handleContinue, otherBankLoanRelationships }) => {
  const bankNames = useSelector(getDatalist).uaeBankName;
  let UAERelationships = [];
  let nonUAERelationships = [];
  forEach(otherBankLoanRelationships, (relationship, index) => {
    if (relationship.basedIn === "UAE") {
      UAERelationships.push({ index, relationship });
    } else {
      nonUAERelationships.push({ index, relationship });
    }
  });
  return (
    <>
      {UAERelationships.length > 0 && (
        <>
          <h6>Banking Relationship Primary Borrower Within UAE</h6>
          {UAERelationships.map((otherBankLoanRelationship, index) => {
            return (
              <Accordian
                key={otherBankLoanRelationship.relationship.bankName || index}
                accordianHeader={getDisplayTextUsingDatalistValue(
                  bankNames,
                  otherBankLoanRelationship.relationship.bankName
                )}
              >
                <PrimaryBorrowerUAE
                  handleContinue={handleContinue}
                  otherBankLoanRelationship={otherBankLoanRelationship}
                  index={index}
                />
              </Accordian>
            );
          })}
        </>
      )}

      {nonUAERelationships.length > 0 && (
        <>
          <h6>Banking Relationship Primary Borrower Outside UAE</h6>
          {nonUAERelationships.map((otherBankLoanRelationship, index) => {
            return (
              <Accordian
                key={otherBankLoanRelationship.relationship.bankName || index}
                accordianHeader={otherBankLoanRelationship.relationship.bankName}
              >
                <PrimaryBorrowerNonUAE
                  handleContinue={handleContinue}
                  otherBankLoanRelationship={otherBankLoanRelationship}
                  index={index}
                />
              </Accordian>
            );
          })}
        </>
      )}
    </>
  );
};

PrimaryBorrowerComponent.propTypes = {
  /**
   * Function to handle form submission and continue to next step
   */
  handleContinue: PropTypes.func.isRequired,

  /**
   * Array of other bank loan relationships with details
   */
  otherBankLoanRelationships: PropTypes.arrayOf(
    PropTypes.shape({
      bankName: PropTypes.string.isRequired,
      basedIn: PropTypes.string.isRequired,
      facilityType: PropTypes.string,
      facilityAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      outstandingAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      currency: PropTypes.string,
      monthlyInstallment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      pending: PropTypes.bool
    })
  ).isRequired
};
